module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-review"
  }, [_c('div', {
    staticClass: "pages-review__wrap"
  }, [(_vm.props.acf.title) ? _c('h2', {
    staticClass: "pages-review__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title)
    }
  }) : _vm._e(), (_vm.props.acf.content) ? _c('p', {
    staticClass: "pages-review__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.content)
    }
  }) : _vm._e(), (_vm.props.acf.scan_image) ? _c('img', {
    staticClass: "pages-review__scan",
    attrs: {
      "src": _vm.props.acf.scan_image,
      "alt": "Scan image"
    }
  }) : _vm._e(), _c('a', {
    staticClass: "pages-review__link",
    attrs: {
      "href": "/smile-assurance-program?skip=1",
      "title": "next"
    }
  }, [_vm._v("Next")]), _c('p', {
    staticClass: "pages-review__text",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_vm._v(" Once on Google, under Mattiacio Orthodontics, click on the \"Reviews\" tab. Scroll down to \"Rate and Review on Google\" and select your star rating and leave us a review!")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c4cd66","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/review/review.pug
// module id = 677
// module chunks = 1